import React, { Component } from 'react';
import { connect } from 'react-redux';
import { hashHistory } from 'react-router';
import Util from '../../../util'
import NavigatorMain from '../../NavigatorMain';
import { getInvestmentDetial,getStopPlan,getStopBuyPlan ,moneyFundPlanStopValidate} from '../../../action/myAssets/InvestPlanAction.js';
import {
  getPayAll
} from '../../../getPay';
import {fundDetailFun} from '../../../common.js'
import ModalSelect from '../../Modal/ModalSelect';
import { myPaymentText } from '../../../action/publicAction';
import {getSuperFundProductIncome} from '../../../action/portfolioAction'

class InvestmentDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pwdFlag:false,
      keyPasswordVal:'',
      ThreeIncome:'',
      dayIncomeDate:''
    };
  }
  componentWillMount(){
    document.title = '定投计划详情'
    this.props.dispatch(getInvestmentDetial(this.props.location.state.planId,this.changeFlag.bind(this)))
    console.log(this.props.inInvestmentDetial)
    if (this.props.location.state.planItem.fundCode.startsWith('SF')) {
      let inData = {
        superFundCode:this.props.location.state.planItem.fundCode,
        periodType:12
      }
      this.props.dispatch(getSuperFundProductIncome(inData,(data)=>{
        let leng = data.incomeDateList.length - 1;
        let IncomeDate = data.incomeDateList[leng] /*最新收益率时间*/
        let ThreeIncome = data.incomeList[leng];
        this.setState({
          dayIncomeDate:IncomeDate.replace(/\//g,"-"),
          ThreeIncome:Util.fomatFloat(ThreeIncome*100)/*近一年收益*/
        })
      },this))
    } 
  }
  changeFlag(){

  }
  change(){
    const {inInvestmentDetial,dispatch}=this.props;
    var currentNavDate=new Date(inInvestmentDetial.publishDate).getTime()
    if (this.props.location.state.planItem.fundCode.startsWith('SF')) {
      let obj={
        name:inInvestmentDetial.fundName,
        fundCode:inInvestmentDetial.fundCode,
        currentNav:inInvestmentDetial.fundValue,
        currentNavDate:currentNavDate
      }
      let params={
        fundName:inInvestmentDetial.fundName,
        fundCode:inInvestmentDetial.fundCode,
        businessType:'T022',
        productType:'G',
        titleHeader:'定投计划修改',
        planId:inInvestmentDetial.planId,
        trustChannelId:inInvestmentDetial.trustChannelId,
        item:obj,
        wanfenshouyi:inInvestmentDetial.wanfenshouyi,
        fundType:inInvestmentDetial.fundType,
        planItem:this.props.location.state.planItem,
        callback:()=>{
        }
      }
      setTimeout(()=>{
        this.props.dispatch(myPaymentText(this.props.location.state.planItem.tradeAmount.toString()))
      },1000)
      getPayAll( window.history.length, params, hashHistory, 'FixedInvestmentSuperFundChange')
    }else{
      let obj={
        name:inInvestmentDetial.fundName,
        fundCode:inInvestmentDetial.fundCode,
        currentNav:inInvestmentDetial.fundValue,
        currentNavDate:currentNavDate
      }
      let params={
        fundName:inInvestmentDetial.fundName,
        fundCode:inInvestmentDetial.fundCode,
        businessType:'T022',
        productType:'G',
        titleHeader:'定投计划修改',
        planId:inInvestmentDetial.planId,
        item:obj,
        wanfenshouyi:inInvestmentDetial.wanfenshouyi,
        fundType:inInvestmentDetial.fundType,
        planItem:this.props.location.state.planItem,
        callback:()=>{}
      }
      getPayAll(window.history.length,params, hashHistory, 'FixedInvestmentChange')
    }
  }
  goFunDetial(){
    let { dispatch,inInvestmentDetial} = this.props;
    let {planItem}=this.props.location.state;
    let superFundCode = planItem.fundCode;
    if (superFundCode.startsWith('SF')) {
      let component;
      component='/SuperFundDetail'
      hashHistory.push({
        pathname:component,
        state:{superFundCode:planItem.fundCode},
        query: {superFundCode:planItem.fundCode}
      })
    }else{
      fundDetailFun('G',inInvestmentDetial.fundCode,window.history.length)
    }
  }
  funRight(){
    const { inInvestmentDetial}=this.props;
    console.log(inInvestmentDetial)
    hashHistory.push({
      pathname: '/InvestmentRecord',
      state: {planId:inInvestmentDetial.planId}
    });
  }
  onChangePwd(val){
    this.setState({
      keyPasswordVal:val
    })
  }
  keyOk(){
    const { 
      dispatch,
      inInvestmentDetial,
    }=this.props;
    let {planItem}=this.props.location.state
    let {
      keyPasswordVal,
    }=this.state;
    let data={
      planId:inInvestmentDetial.planId,
      password:Util.encrypt(keyPasswordVal),
    }
    console.log(inInvestmentDetial)
    const pushResult = (i,result) => {
      if (i==1) {
          hashHistory.replace({
            pathname:'/Success',
            state: {
              title:'定投计划',
              content:'您终止的定投计划已被受理',
              dataSouse:[['终止编号',result.content.planId]],
              souseVal:['查看我的投资','返回智投首页'],
            }
          });
      } else if (i==3) {
          hashHistory.replace({
            pathname:'/ErrorResult',
            state: {
              title:'定投计划',
              content:'您终止的定投计划失败',
              content2:result,
              dataSouse:[],
              souseVal:['返回智投首页','联系客服'],
            }
          });
      }
    }  
    if (planItem.type=='12') {
      dispatch(getStopPlan(data,pushResult))
    }else if(planItem.type=='0'){
      dispatch(getStopBuyPlan(data,pushResult))
    }else if(planItem.type=='11'||planItem.type=='2'){
      dispatch(moneyFundPlanStopValidate(data,pushResult))

    }

  }
  render(){
    let {name,code,planItem}=this.props.location.state
    let {inInvestmentDetial}=this.props;
    console.log('定投详情',inInvestmentDetial)
    let arr=['','','一','二','三','四','五']
    let str='';
    if (inInvestmentDetial.periodType=='0') {
      str='每月'+inInvestmentDetial.tradeDates[0]+'日';
    } else if (inInvestmentDetial.periodType=='1') {
      str='每周周'+arr[inInvestmentDetial.tradeDates[0]]
      
    } else if (inInvestmentDetial.periodType=='3'){
      str='每双周周'+arr[inInvestmentDetial.tradeDates[0]]
    }
    return (
        <div className="container" >
          <ModalSelect/>
          <NavigatorMain>
            <div className="header black">
              <div onClick={hashHistory.goBack}><span className="headerLeftBtn"></span></div>
              <div>定投计划详情</div>
              <div style={{marginRight:13}} onClick={()=>this.funRight()}>定投记录</div>
            </div>
          </NavigatorMain>
          <div className='content paddB40'>
            <div className='plan-detial-header' onClick={()=>this.goFunDetial()}>
              <div className='plan-detial-header-left'>
                <img src={require('../../../img/logo1.png')} />
                <div/>
              </div>
              <div className='plan-detial-header-center'>
                <div className='plan-detial-header-center-top'>{name+'('+code+')'}</div>
                <div className='plan-detial-header-center-bottom'>
                {
                  this.props.location.state.planItem.fundCode.startsWith('SF')?
                  `近一年收益:${Util.fomatFloat(Util.formatStr(this.state.ThreeIncome),2)}%(${this.state.dayIncomeDate})`:
                  inInvestmentDetial.fundType=='理财型'||inInvestmentDetial.fundType=='货币型'?
                  `万份收益:${Util.fomatFloat(Util.formatStr(inInvestmentDetial.wanfenshouyi),4)}(${Util.formatStr(inInvestmentDetial.publishDate)})`:
                  `最新净值:${Util.fomatFloat(Util.formatStr(inInvestmentDetial.fundValue),3)}(${Util.formatStr(inInvestmentDetial.publishDate)})`
                }
                </div>
              </div>
              <div className='plan-detial-header-right'>
                <img src={require('../../../img/rightArrow.png')} className='plan-detial-header-right'/>
              </div>
            </div>
            <div className='plan-detial-info'>
              <div className='plan-detial-info-box'>
                <p>{inInvestmentDetial.tradeAmount}元</p>
                <span>定投金额</span>
              </div>
              <div className='plan-detial-info-box'>
                <p>{str.length==0?'--':str}</p>
                <span>定投周期</span>
              </div>
              <div className='plan-detial-info-box'>
                <p>{planItem.trustChannelName}</p>
                <span>支付渠道</span>
              </div>
            </div>
            <div className='plan-detial-info-time'>
              下一扣款日:{Util.returnDate(inInvestmentDetial.nextTradeDate)}
            </div>
            <div className='plan-detial-barbox'>
              <div className='plan-detial-barbox-bar'>
                <span>累计投资</span>
                <span>{inInvestmentDetial.amount}</span>
              </div>
              <div className='plan-detial-barbox-bar'>
                <span>定投次数</span>
                <span>{inInvestmentDetial.count}</span>
              </div>
            </div>
          </div>
          <div className='plan-detial-bottom'>
            <div onClick={()=>this.change()}>修改</div>
            <div onClick={()=>{this.setState({pwdFlag:true})}}><img src={require('../../../img/icon11.png')} />终止</div>
          </div>
          {
            this.state.pwdFlag?
            <div  style={{position:'fixed',top:0,width:'100%',height:'100%',background:'rgba(52,52,52,0.4)'}}>
              <div style={{position:'fixed',bottom:0,width:'100%',height:'70%',background:'#fff'}}>
                <div style={{position:'relative',height:'45px',lineHeight:'45px',textAlign:'center',borderBottom:'0.005rem solid rgb(224,227,279)',fontSize:'0.3rem'}}>
                  交易密码
                  <img src={require('../../../img/close.png')}  style={{position:'absolute',left:0,width:'0.88rem',height:'0.88rem'}} onClick={()=>{this.setState({pwdFlag:false})}}/>
                  <span  style={{position:'absolute',top:0,right:0,width:'45px',fontSize:'13px'}} className='red-t' onClick={()=>{this.keyOk()}}> 确认</span>
                </div>
                <div style={{padding:'0.3rem 0.3rem 0rem 0.3rem',fontSize:'13px'}}>
                  {this.props.location.state.fundRisk?'温馨提示：本人已完成风险测评问卷，并对申请购买的基金产品风险等级高于本人的风险承受能力情况已知晓，并已充分了解该基金产品的风险特征和可能的不利后果。本人仍坚持自愿投资该基金产品，并自愿承担由此可能产生的一切不利后果和损失。基金募集机构及工作人员在销售过程中，不存在直接或间接主动向本人推介该基金产品或服务的行为。':''}
                </div>
                <div style={{height:'45px',padding:'13px'}}>
                  <input autocomplete="off" onChange={(e)=>this.onChangePwd(e.target.value)} autofocus="autofocus" style={{height:'45px',width:'100%',fontSize:'0.3rem',border:'1px solid #afafaf',borderRadius:'0.1rem'}} type="password"  placeholder=""/>
                </div>
              </div>
            </div>
            :null
          }
        </div>
    );
  }
}


function mapStateToProps(state, ownProps) {
  return {
   inInvestmentDetial:state.InvestPlanReducer.inInvestmentDetial,
  }
}
export default connect(mapStateToProps)(InvestmentDetail);



// WEBPACK FOOTER //
// ./src/components/myAssets/investPlan/InvestmentDetail.js